export class PlacardLocationSession {
    public placardLocation: string = '';
    public metalBoxInd: boolean;
    public pickupLocation: string = '';
    public additionalLocationDetails: string = '';
    public lockCombination: string = '';
    public pickupLocationKey: string = '';
    public placardLocationKey: string = '';
}